/* eslint-disable @typescript-eslint/no-duplicate-enum-values */
export enum HANDS_UP_TYPES {
  Abertura_Conta = 'conta',
  FP = 'FP',
  Minha_Assessoria = 'Minha assessoria',
  Investimentos = 'Investimentos',
  Boletador = 'Boletador',
  Empresarial_Credito = 'Empresarial',
  Empresarial_Energia = 'Energia',
  Aquisicao_de_bens_Financiamento = 'Aquisição de bens',
  Aquisicao_de_bens_Home_Equity = 'Aquisição de bens',
  Aquisicao_de_bens_Consorcio = 'Consórcio',
  Seguros = 'Seguros',
  Sucessorio = 'Sucessório',
  Previdencia = 'Previdência',
  RV = 'RV',
  Cartoes = 'Crédito',
  Cambio = 'Câmbio',
  Vivendo_de_renda_EQI_account = 'conta',
  Vivendo_de_renda_EQI_Advisory = 'Previdência',
}

export const handsUpKeys = Object.keys(HANDS_UP_TYPES);
